import { mountingNode } from '../shared/components/App.css'

export const MOUNTING_NODES = [...document.querySelectorAll(`.${mountingNode}`)]

export const getInitialState = node => {
  const dataInitialState = node.getAttribute('data-initial-state')
  if (dataInitialState) {
    return JSON.parse(node.getAttribute('data-initial-state'))
  }
  return {}
}



// WEBPACK FOOTER //
// ./src/client/globals.js